@if (form) {
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-100">
        <div fxLayout="row wrap" fxLayoutAlign="start center">
            @if (form.controls.fileType) {
                <af-dictionary-selector dictionaryName="attached_doc"
                                        class="min-max-w-400"
                                        [label]="label"
                                        [hintTranslationKey]="hintTranslationKey"
                                        placeholder="i18n_af_placeholderSelectDocumentType"
                                        [isDependentDictionary]="!!parentDictionaryFormControl"
                                        [excludeFromDictionary]="excludeFromDictionary"
                                        [parentDictionaryFormControl]="parentDictionaryFormControl"
                                        [predefinedValue]="documentAttachment?.docType ?? defaultDocType"
                                        [filterDictionaryBy]="filterDictionaryBy"
                                        [excludeItemsWithCode1]="excludeItemsWithCode1"
                                        [control]="form.controls.fileType"/>
            }
            @if (dropzoneMode === 'drop-zone' && hasAddDocumentButton) {
                <ui-kit-button
                    type="text"
                    buttonType="button"
                    iconPosition="left"
                    icon="ic_attach"
                    class="ml-16"
                    [label]="'i18n_af_buttonAddDocument' | translate"
                    (clickListener)="dropZoneControllerComponent.openPicker()"/>
            }
        </div>
        <af-drop-zone #dropZoneControllerComponent
                      formControlName="files"
                      class="w-100"
                      label="i18n_af_attachFileTitle"
                      hint="i18n_af_attachFileHint"
                      [dropZoneStyle]="dropZoneStyle"
                      [hasMargin]="hasType"
                      [bucket]="bucket"
                      [maxFileSize]="maxFileSize"
                      [mode]="dropzoneMode"
                      [mimeTypes]="mimeTypes"
                      [multiple]="multiple"
                      [downloadable]="downloadable"/>
    </form>
}
